import React from "react";
import { Checkbox as BootstrapCheckbox } from "react-bootstrap";
import InfoTooltip from "../lib/info";

class Checkbox extends BootstrapCheckbox {
  render() {
    const { checkboxLabel, infoText, infoDirection, ...props } = this.props;
    let children = [<span key={"label"}>{checkboxLabel}</span>];
    if (infoText) {
      children = children.concat(
        <InfoTooltip key={"tooltip"} helpText={infoText} direction={infoDirection} />
      );
    }
    return <BootstrapCheckbox {...props}>{children}</BootstrapCheckbox>;
  }
}

export default Checkbox;
